import { api } from '@src/api/api'
import { PayType, RecurrentType } from '@src/store/ducks/pay/types'

export const payApi = {
  getPayAndDebInfo(accountId: number, type: number, dateStart: string, dateEnd: string) {
    return api.get<PayType[]>('/v1/user/get-history', {
      accountId, type, dateStart, dateEnd,
    })
  },
  getPaymentUrl(sum: number, isReccurent: boolean, accountId: number, payId?: string | null) {
    return api.post<string>('/v1/payments/get-payment-url', {
      sum, isReccurent, accountId, payId,
    })
  },
  getRecurrentCard(accountId: number) {
    return api.get<RecurrentType>('/v1/payments/get-reccurent-card', { accountId })
  },
  setAutoPay(accountId: number) {
    return api.put('/v1/payments/change-reccurent-card', { accountId })
  },
  addCreditLimit(accountId: number, account: string) {
    return api.post('/v1/payments/add-credit-limit', { accountId, account })
  },
  getCreditLimitDescription() {
    return api.get<string>('/v1/user/credit-limit')
  },
}
